import { render } from "./CartProductLabel.vue?vue&type=template&id=f153c196&lang=pug"
import script from "./CartProductLabel.vue?vue&type=script&lang=js"
export * from "./CartProductLabel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__